import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const POINTS = [
    "Career pathways in carbon, biodiversity, restoration and natural capital",
    "Training designed for delivery on Country, with Elders and practitioners",
    "From participation to leadership — assessing, managing and verifying the work",
];

export default function LeadershipPreview() {
    return (
        <section
            id="leadership"
            data-testid="leadership-preview-section"
            className="py-24 md:py-32 lg:py-40 bg-bone2 grain relative overflow-hidden"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12 items-start">
                    <div className="col-span-12 lg:col-span-5">
                        <span className="number-mark text-ink2">§ 07 / Program</span>
                        <h2
                            data-testid="leadership-preview-heading"
                            className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-ink"
                        >
                            Indigenous
                            <br />
                            environmental
                            <br />
                            <em className="italic font-light text-eucalyptus">
                                leadership.
                            </em>
                        </h2>
                        <p className="mt-8 text-ink2 text-lg md:text-xl leading-relaxed max-w-md">
                            <span className="text-ink">Carbon on Country</span>{" "}
                            — our program for building careers, training and
                            decision-making authority across the Indigenous
                            environmental sector. Carbon is one pathway among
                            many.
                        </p>
                    </div>

                    <div className="col-span-12 lg:col-span-7 lg:pl-12">
                        <ul
                            data-testid="leadership-preview-points"
                            className="divide-y divide-rule border-t border-b border-rule"
                        >
                            {POINTS.map((p, i) => (
                                <li
                                    key={i}
                                    className="py-6 md:py-8 flex items-start gap-6"
                                >
                                    <span className="number-mark text-ochre pt-2 shrink-0">
                                        — {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <span className="font-serif text-2xl md:text-3xl leading-[1.15] text-ink">
                                        {p}
                                    </span>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-10 flex flex-wrap gap-4">
                            <Link
                                to="/leadership"
                                data-testid="leadership-preview-cta"
                                className="inline-flex items-center gap-3 px-7 py-4 bg-ink text-bone text-[11px] tracking-[0.22em] uppercase hover:bg-eucalyptus transition-colors"
                            >
                                Explore the program
                                <ArrowRight size={16} strokeWidth={1.5} />
                            </Link>
                            <Link
                                to="/leadership#pathways"
                                data-testid="leadership-preview-pathways"
                                className="inline-flex items-center px-7 py-4 border border-ink text-ink text-[11px] tracking-[0.22em] uppercase hover:bg-ink hover:text-bone transition-colors"
                            >
                                Career pathways
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
